import React from 'react'
import PropTypes from 'prop-types'
import { mergeProps } from 'src/util'
import styles from './Textarea.scss'

const Textarea = ({ color, active, disabled, error, ...domProps }) => {
  return (
    <textarea
      {...mergeProps()(
        {
          disabled,
          className: [styles.textarea, { [styles.active]: active, [styles.error]: error, [styles.disabled]: disabled }],
        },
        domProps
      )}
    />
  )
}

Textarea.defaultProps = {
  color: 'light',
}

Textarea.propTypes = {
  /**
   * The focus color.
   */
  color: PropTypes.string,
  /**
   * Whether the focus color should be applied.
   */
  active: PropTypes.bool,
  /**
   * Whether the input is disabled or not.
   */
  disabled: PropTypes.bool,
  /**
   * In case of error.
   */
  error: PropTypes.node,
}

export default Textarea
